export const registrationConstants = {
  REGISTRATION_REQUEST: "REGISTRATION_REQUEST",
  REGISTRATION_SUCCESS: "REGISTRATION_STATUS",
  REGISTRATION_FAILURE: "REGISTRATION_FAILURE",
  REGISTRATION_COUNTRIES: "REGISTRATION_COUNTRIES",
  REGISTRATION_CITIES: "REGISTRATION_CITIES",
  REGISTRATION_STATUS: "REGISTRATION_STATUS",
  REGISTRATION_STATUS_FAILURE: "REGISTRATION_STATUS_FAILURE",
  RESEND_EMAIL: "RESEND_EMAIL",
  INVALID_TOKEN: "invalid_token",
};
